<template>
  <v-container fluid>
    <v-combobox
      v-model="params"
      :items="offers"
      :search-input.sync="search"
      label="Товары для добавления"
      item-value="id"
      multiple
      persistent-hint
      small-chips
      no-filter
    >
      <template #selection="{ attrs, item, parent }">
        <v-chip label outlined v-bind="attrs">
          <span v-if=" item !== undefined" class="pr-2">
            {{ item.id }} {{ item.name }}
          </span>
          <v-icon small @click="parent.selectItem(item)">
            mdi-close
          </v-icon>
        </v-chip>
      </template>
      <template #item="{ item }">
        ID:{{ item.id }} {{ item.name }}
      </template>

      <template #no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title> Введите для поиска </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>
  </v-container>
</template>

<script>
import { Offers } from '@/graphql/offers'
export default {
  apollo: {
    Offers: {
      query: Offers,
      result ({ data, loading }) {
        if (data.offers.offers !== null) {
          this.offers = data.offers.offers
        }
        this.loading = false
      },
      variables () {
        const sort = []
        return {
          sort,
          search: [{ name: 'id', value: this.search }],
          limit: 20,
          offset: 0
        }
      },
      update: data => data.Offers
    }
  },
  props: {
    default: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    openDialog: {
      type: Boolean
    }
  },
  data: () => ({
    offers: [],
    search: null
  }),
  computed: {
    params: {
      get () {
        return this?.default?.map((i) => {
          const offer = this.offers.filter((f) => { return f.id === i })[0]
          return offer !== undefined ? offer : { id: i, name: 'неизвестный' }
        })
      },
      set (val) {
        this.$emit('change', val.filter(i => i.id).map(i => i.id))
      }
    }
  },
  watch: {
    search (val) {
      if (val && val.length > 0) {
        this.$apollo.queries.Offers.refetch()
      }
    }
  }
}
</script>
